document.addEventListener('DOMContentLoaded', function () {
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;

    // Minimum distance (in pixels) to register as a swipe
    const minSwipeDistance = 100;

    document.addEventListener('touchstart', function (event: TouchEvent) {
        touchStartX = event.changedTouches[0].screenX;
        touchStartY = event.changedTouches[0].screenY;
    }, false);

    document.addEventListener('touchend', function (event: TouchEvent) {
        touchEndX = event.changedTouches[0].screenX;
        touchEndY = event.changedTouches[0].screenY;
        handleGesture();
    }, false);

    function handleGesture() {
        const xDiff = touchEndX - touchStartX;
        const yDiff = touchEndY - touchStartY;

        // 1. Check if horizontal movement is greater than vertical movement
        //    (This prevents going back when the user is just scrolling down)
        if (Math.abs(xDiff) > Math.abs(yDiff)) {

            // 2. Check if the swipe distance is long enough
            if (Math.abs(xDiff) > minSwipeDistance) {

                // 3. Check direction: Left to Right (Swipe Back)
                if (xDiff > 0) {
                    console.log("Swiped Right -> Going Back");
                    // Only go back if there is history
                    if (window.history.length > 1) {
                        window.history.back();
                    }
                }
                /* // Optional: Right to Left (Swipe Forward)
                else {
                    window.history.forward();
                }
                */
            }
        }
    }
});
